import React from "react";
import { SlateListPopover } from "../SlateListPopover";
import styles from "./EntityRefPopover.module.scss";
import type { EntityRefOption } from "./entityRefOptions.types";

interface EntityRefPopoverProps {
    isOpen: boolean;
    onClose: () => void;
    anchorRef: React.RefObject<HTMLSpanElement | null>;
    options: EntityRefOption[];
    activeIndex: number;
    setActiveIndex: (index: number) => void;
    onSelect: (option: EntityRefOption) => void;
    emptyText: string;
    isLoading: boolean;
}

export const EntityRefPopover: React.FC<EntityRefPopoverProps> = ({
    isOpen,
    onClose,
    anchorRef,
    options,
    activeIndex,
    setActiveIndex,
    onSelect,
    emptyText,
    isLoading,
}) => (
    <SlateListPopover
        isOpen={isOpen}
        onClose={onClose}
        anchorRef={anchorRef}
        items={options}
        getItemKey={(option) => option.key}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        onSelect={onSelect}
        emptyState={
            <div className={styles.empty}>
                {isLoading ? "Loading…" : emptyText}
            </div>
        }
        renderItem={(option) => (
            <>
                <span className={styles.icon} aria-hidden>
                    {option.icon}
                </span>
                <span className={styles.title}>{option.title}</span>
                {option.description && (
                    <span className={styles.description}>
                        {option.description}
                    </span>
                )}
            </>
        )}
    />
);
